import styled from "styled-components";

export const FormSearchStyled = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 5.55rem;
  width: 100%;

  & > input {
    border: none;
    outline: none;
    font-size: 1.6rem;
    font-weight: 400;
  }

  & > input::placeholder {
    color: var(--color-grey-20);
  }

  & > button {
    display: flex;
    justify-content: center;
    width: 5.3rem;
    height: 4rem;

    & > img {
      align-self: center;
    }
  }
`;
